import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SortOrder } from '@/components/ui/table'
import { Checklist, ChecklistStatus, ChecklistType } from '@/models/features'

import { authAPI } from '../new-api'

export interface GetChecklistsRequest {
  buildingId?: number
  skip?: number
  limit?: number
  status?: ChecklistStatus
  search?: string
  type?: ChecklistType
  parentChecklistId?: number[]
  clientId?: number[]
  fromDate?: number
  toDate?: number
  unitId?: number
  sortBy?: string
  sortOrder?: SortOrder
}

export interface GetChecklistsResponse {
  data: Checklist[]
  total: number
  skip: number
  limit: number
  countByStatus: Record<ChecklistStatus, number>
}

export const GET_CHECKLISTS_BASE_QUERY_KEY = 'useGetChecklists'

export const getChecklistsQueryKey = (data: GetChecklistsRequest) => [
  GET_CHECKLISTS_BASE_QUERY_KEY,
  data,
]

export const getChecklists = async (data: GetChecklistsRequest, signal?: AbortSignal) => {
  const { buildingId, ...params } = data

  const response = await authAPI.get<GetChecklistsResponse>(`/checklist-unified/${buildingId}`, {
    params,
    signal,
  })
  return response.data
}

export const useGetChecklists = (data: GetChecklistsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getChecklists(data, signal),
    queryKey: getChecklistsQueryKey(data),
  })
}
